import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: BACKEND_URL,
  timeout: 30000,
});

// Save verification results to database
export const saveVerification = async (verificationData) => {
  try {
    const response = await api.post('/api/verifications', {
      livenessSessionId: verificationData.sessionId,
      livenessResults: verificationData.livenessResults,
      documentData: verificationData.documentData,
      faceCompareResults: verificationData.faceCompareResults,
      signatureResults: verificationData.signatureResults,
      membershipData: verificationData.membershipData,
      frontS3Key: verificationData.frontS3Key,
      backS3Key: verificationData.backS3Key,
      referenceImageS3Key: verificationData.referenceImageS3Key,
    });
    
    return response.data;
  } catch (error) {
    console.error('Error saving verification:', error);
    throw error;
  }
};

// Retrieve verification by ID
export const getVerification = async (verificationId) => {
  try {
    const response = await api.get(`/api/verifications/${verificationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching verification:', error);
    throw error;
  }
};

// List all verifications
export const listVerifications = async (limit = 20, offset = 0) => {
  try {
    const response = await api.get('/api/verifications', {
      params: { limit, offset }
    });
    return response.data;
  } catch (error) {
    console.error('Error listing verifications:', error);
    throw error;
  }
};

// Update verification status or results
export const updateVerification = async (verificationId, updateData) => {
  try {
    const response = await api.patch(`/api/verifications/${verificationId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating verification:', error);
    throw error;
  }
};

// Delete verification
export const deleteVerification = async (verificationId) => {
  try {
    const response = await api.delete(`/api/verifications/${verificationId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting verification:', error);
    throw error;
  }
};

// Upload image for verification
export const uploadImage = async (verificationId, documentType, base64ImageData) => {
  try {
    // Remove data: URI prefix if present
    let imageData = base64ImageData;
    if (imageData.includes(',')) {
      imageData = imageData.split(',')[1];
    }

    const response = await api.post('/api/images', {
      verificationId,
      documentType,
      imageData
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

// Retrieve images for verification
export const getImages = async (verificationId, documentType = null) => {
  try {
    const params = {};
    if (documentType) {
      params.type = documentType;
    }

    const response = await api.get(`/api/images/${verificationId}`, { params });
    return response.data.images;
  } catch (error) {
    console.error('Error retrieving images:', error);
    throw error;
  }
};

// Retrieve specific image by ID
export const getImageById = async (verificationId, imageId) => {
  try {
    const response = await api.get(`/api/images/${verificationId}/${imageId}`);
    return response.data;
  } catch (error) {
    console.error('Error retrieving image:', error);
    throw error;
  }
};

export default api;
